function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaze(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 588.9 479.3",
    style: {
      enableBackground: "new 0 0 588.9 479.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "maze"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0A0A0A"
    },
    points: "142.5,0 142.5,24.7 211.6,24.7 211.6,48.2 47.7,48.2 47.7,108.7 24,108.7 23.8,24.5  118.5,24.2 118.5,0 0.2,0 0,479.3 24.9,479.3 24.7,383.9 47.7,383.9 47.7,432.3 109.8,432.3 109.8,407.5 72.4,407.5 72.4,392.8  101.1,392.8 493,392.8 493,367.7 72.4,367.7 72.4,312.5 47.7,312.5 47.7,360.2 24.6,360.2 24.3,236.5 47.7,236.5 47.7,288.7  72.1,288.7 72.1,170 47.7,170 47.7,212.7 24.3,212.7 24.1,132.5 47.7,132.5 47.7,153.7 62.7,153.7 72,153.7 72.1,153.7  101.2,153.7 494.2,153.7 494.2,128.6 72.1,128.6 72.1,73.2 279.4,73.2 279.4,48.2 235.6,48.2 235.6,24.7 329.2,24.7 353.7,24.7  353.7,48.2 303.4,48.2 303.4,73.2 399.6,73.2 399.6,48.2 377.7,48.2 377.7,24.7 564.7,24.7 564.7,48.2 541,48.2 422.3,48.2  422.3,72.6 517,72.6 517,87.3 91.9,87.3 91.9,112.4 121.4,112.4 517,112.4 517,120.6 541,120.6 541,71.9 564.7,71.9 564.7,149.6  541,149.6 541,144.3 517,144.3 517,193.1 541,193.1 541,173.3 564.7,173.3 564.7,231.8 541,231.8 541,215.9 516.3,215.9  516.3,300.6 541,300.6 541,255.5 564.7,255.5 564.7,336.8 541,336.8 541,324.3 517.5,324.3 517.5,324.3 96,324.3 96,349.3  125.1,349.3 516.3,349.3 516.3,407.3 516.6,432.3 541,432.3 541,360.5 564.7,360.5 564.7,455.4 449.1,455.4 449.1,432.3  493,432.3 493,407.3 282.6,407.3 282.6,432.3 425.2,432.3 425.2,455.4 399.6,455.4 399.6,479.1 588.9,479.1 588.9,455.4  588.9,24.7 588.9,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0A0A0A"
    },
    points: "375.9,455.4 190.1,455.4 190.1,432.3 260.5,432.3 260.5,407.5 133.8,407.5 133.8,432.3  166.1,432.3 166.1,455.4 24.9,455.4 24.9,479.3 375.9,479.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0A0A0A"
    },
    points: "189.4,193.2 212.9,193.2 212.9,170 96,170 96,193.2 96,193.2 142.8,193.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 193.2,
    style: {
      fill: "#0A0A0A"
    },
    width: 23.3,
    height: 116.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.8,
    y: 193.2,
    style: {
      fill: "#0A0A0A"
    },
    width: 23.3,
    height: 116.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.3,
    y: 193.2,
    style: {
      fill: "#0A0A0A"
    },
    width: 23.3,
    height: 116.9
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "a",
    style: {
      fill: "#0A0A0A"
    },
    points: "305.9,310.1 305.9,193.2 305.9,170 236,170 236,193.2 282.7,193.2 282.6,266.2  282.6,265.9 259.2,265.9 259.3,193.2 236,193.2 236,310.1 259.2,310.1 259.2,289.4 282.6,289.4 282.6,310.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "z",
    style: {
      fill: "#0A0A0A"
    },
    points: "353.3,234.6 329.2,234.6 329.2,255.5 329.2,255.5 329.2,286.4 329.2,286.4  329.2,310.1 399.6,310.1 399.6,286.4 399.6,277.6 378.2,277.6 378.2,286.4 353.9,286.4 353.9,255.5 375.9,255.5 399.6,255.5  399.6,191.9 399.6,181.6 399.6,170 329.2,170 329.2,206 354,206 354,193.2 376.2,193.2 375.9,234.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "e",
    style: {
      fill: "#0A0A0A"
    },
    points: "493,214.7 493,194.3 493,173.8 493,170.3 472.7,170.3 442.6,170.3 422.3,170.3  422.3,193.2 422.3,194.3 422.3,310.1 446.1,310.1 468.7,310.1 493,310.1 493,269.1 468.7,269.1 468.7,286.4 446.1,286.4  446.1,253.9 493,253.9 493,229.9 445.9,229.9 445.5,194.3 468.7,194.3 468.7,214.7  "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaze);
export default __webpack_public_path__ + "static/media/maze.3ea444d3.svg";
export { ForwardRef as ReactComponent };